import type { DataSourceDataParams } from "@infinite-table/infinite-react";
import type { Pead } from "epsm-api-types/models";
import { useEffect, useState } from "react";
import config from "../../../config";

const { initialDataParams } = config;

export function useSetDataParamsByTicker(ticker: string) {
	const [dataParams, setDataParams] =
		useState<Partial<DataSourceDataParams<Pead>>>(initialDataParams);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <dataParams in deps is causing an infinite loop>
	useEffect(() => {
		const params: Partial<DataSourceDataParams<Pead>> = {
			...dataParams,
			filterValue: [
				{
					field: "ticker",
					filter: { operator: "eq", type: "string", value: ticker },
				},
			],

			sortInfo: [
				{
					field: "earning_day",
					dir: -1,
				},
			],
		};

		setDataParams(params);
	}, [ticker]);

	return { dataParams };
}
